<template>
  <div class="app login">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12">
          <div class="login-left">
            <img src="../../../assets/img/logo.svg" class="login-logo">
            <div class="login-fields">

              <div v-if="submitResponse.success">
                <h1>{{$t('PASSWORDCHANGED')}}</h1>
                <div class="alert alert-success">
                  {{$t('PASSWORD_RESET_SUCCESS_MESSAGE')}}
                </div>
                <div class="mt-3 text-center">
                  <router-link to="/login" class="text-muted">{{$t('BACKTOLOGIN')}}</router-link>
                </div>
              </div>

              <div v-else>
                <h1>{{$t('RESETPASSWORD')}}</h1>
                <p class="text-muted mb-4">{{$t('ENTER_NEW_PASSWORD_DETAILS')}}</p>

                <b-form-fieldset v-bind:label="$t('NEWPASSWORD')" class="full-input-group mb-3">
                    <b-form-input type="password" v-model="password" v-on:keyup.13="handlePasswordReset"></b-form-input>
                </b-form-fieldset>

                <b-form-fieldset v-bind:label="$t('CONFIRMPASSWORD')" class="full-input-group mb-3">
                    <b-form-input type="password" v-model="passwordConfirm" v-on:keyup.13="handlePasswordReset"></b-form-input>
                </b-form-fieldset>

                <p class="text-muted small mb-3">{{$t('PASSWORDREQUIREMENTS')}}</p>

                <p class="bg-danger" v-if="submitResponse.error && submitResponse.notice">
                  {{$t(submitResponse.notice)}}
                </p>

                <div class="row">
                  <div class="col-12">
                    <button type="button" v-on:click.prevent="handlePasswordReset" class="btn-bis btn-primary w-100" :disabled="!canSubmit">
                      {{$t('CHANGEPASSWORD')}}
                    </button>
                  </div>
                  <div class="col-12 mt-3 text-center">
                    <router-link to="/login" class="text-muted">{{$t('BACKTOLOGIN')}}</router-link>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12 hidden-on-small">
          <div class="login-tehnician"><img src="../../../assets/img/login-technician.png"></div>
          <div class="login-bg-img">&nbsp;</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'PasswordReset',
  data()
  {
    return {
      verifyCode: '',
      password: '',
      passwordConfirm: '',
      submitResponse: {}
    }
  },
  created()
  {
    this.verifyCode = this.$route.params.verifyCode || '';

    if (!this.verifyCode)
    {
      this.submitResponse = {
        error: true,
        notice: 'INVALIDRESETTOKEN'
      };
    }
  },
  computed:
  {
    canSubmit()
    {
      return this.password
             && this.password.length >= 8
             && this.passwordConfirm
             && this.password === this.passwordConfirm
             && this.verifyCode;
    }
  },
  methods:
  {
    ...mapActions({
      actResetPassword: 'resetPassword'
    }),
    async handlePasswordReset(bvEvt)
    {
      const me = this;

      if (bvEvt && bvEvt.preventDefault)
      {
        bvEvt.preventDefault();
      }

      if (me.password !== me.passwordConfirm)
      {
        me.submitResponse = {
          error: true,
          notice: 'PASSWORDSDONOTMATCH'
        };
        return;
      }

      if (me.password.length < 8)
      {
        me.submitResponse = {
          error: true,
          notice: 'PASSWORDTOOSHORT'
        };
        return;
      }

      try
      {
        const response = await me.actResetPassword({
          verifyCode: me.verifyCode,
          password: me.password,
          passwordConfirm: me.passwordConfirm
        });

        if (response.error)
        {
          me.submitResponse = {
            error: true,
            notice: response.notice
          };
        }
        else
        {
          me.submitResponse = response;
        }
      }
      catch (error)
      {
        me.submitResponse = {
          error: true,
          notice: 'GENERICERROR'
        };
      }
    }
  }
}
</script>
